import styled from '@emotion/styled';
import { Button, Paragraph } from '@triumph/design-system';

export const AssignButtonGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 0;
`;

export const AssignedButton = styled(Button)`
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: none;
`;

export const UnassignButton = styled(Button)`
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    &:hover:not(:disabled) {
        background-color: #ffebee;
        border-color: #d32f2f;
        color: #d32f2f;

        svg {
            color: #d32f2f;
        }
    }
`;

export const ConflictError = styled(Paragraph)`
    color: #d32f2f;
    margin: 4px 0 0 0;
    font-size: 12px;
`;
